module.exports = __webpack_public_path__ + "media/components/country-flag/static/me-4e15631dbd14924c12e5aaf1b5dc4197.svg";